<template lang='pug'>
	.home-pleca-contenido-verde
		.contenedor-pleca-contenido
			.contenido
				.modulo
					h1: | Do-it-Yourself Residential Title 24
					p
						|Save time and money by entering information about your design into our convenient "take-off" tool.
						br
						br
						| Get your Title 24 Report at a deep discount, and pay yourself the difference! Start Now!
					router-link.btn(to='/do-it-yourself')
						span
							| Read more
				.modulo.imagen
					.centrada
						img(src='~Img/laptop_macbookpro.png')
</template>

<script>
export default {
	name: 'pleca-verde'
}
</script>



// WEBPACK FOOTER //
// src/components/home/PlecaVerde.vue